/**
 * In-memory UI/session flags for the Excel task pane (not persisted; cleared when the WebView ends).
 * Tokens remain in {@link traceTokenStore}; this object only tracks transient auth-dialog and switch-org UX state.
 */
export class TaskPaneUiSessionState {
    private authDialogMessageHandled = false;

    private switchOrganisationFlowActive = false;

    /** True until managed organisations are loaded and, when required, one is selected. */
    private organisationResolutionPending = false;

    private organisationResolutionError: string | null = null;

    /** True after the auth dialog posts a final `messageParent` (success or handled error). */
    isAuthDialogMessageHandled(): boolean {
        return this.authDialogMessageHandled;
    }

    setAuthDialogMessageHandled(handled: boolean): void {
        this.authDialogMessageHandled = handled;
    }

    /** True while the user is switching organisation (expanded login UI; session kept until Continue). */
    isSwitchOrganisationFlowActive(): boolean {
        return this.switchOrganisationFlowActive;
    }

    setSwitchOrganisationFlowActive(active: boolean): void {
        this.switchOrganisationFlowActive = active;
    }

    isOrganisationResolutionPending(): boolean {
        return this.organisationResolutionPending;
    }

    setOrganisationResolutionPending(pending: boolean): void {
        this.organisationResolutionPending = pending;
    }

    getOrganisationResolutionError(): string | null {
        return this.organisationResolutionError;
    }

    setOrganisationResolutionError(message: string | null): void {
        this.organisationResolutionError = message;
    }
}

/** Single instance for the task-pane bundle. */
export const taskPaneUiSession = new TaskPaneUiSessionState();
